import {WidgetConfig} from "../../types/config";
import ComponentConfig from "../../config/componentConfig";

export default class ChatHelper {

    private endAgentAvailabilityCheck: boolean = false;

    constructor(
        private widgetConfig: WidgetConfig,
        private componentConfig: ComponentConfig,
        private agentChatAvailableElement: HTMLElement | null,
        private noAgentChatAvailableElement: HTMLElement | null = null,
    ) {
    }

    async initAgentAvailabilityCheck(): Promise<void>
    {
        if(!this.componentConfig.allowAgentChat) {
            return;
        }

        this.endAgentAvailabilityCheck = false;

        let agentsAvailabilityCheckInterval = this.widgetConfig.getAgentsAvailabilityCheckInterval();
        let maxAgentsAvailabilityCheckCalls = this.widgetConfig.getMaxAgentsAvailabilityCheckCalls();
        let callCounter = 0;

        await this.prepareAgentChatButton();

        let intervalId = setInterval(() => {
            callCounter++;
            if (callCounter > maxAgentsAvailabilityCheckCalls || this.endAgentAvailabilityCheck) {
                clearInterval(intervalId);
            } else {
                this.prepareAgentChatButton();
            }
        }, agentsAvailabilityCheckInterval * 1000);
    }

    async prepareAgentChatButton(): Promise<void>
    {
        if(await this.checkAgentAvailability()) {
            this.showAgentChatButton(true);
        } else {
            this.showAgentChatButton(false);
        }
    }

    public showAgentChatButton(showButton: boolean): void
    {
        if(this.agentChatAvailableElement === null) {
            return;
        }

        if(showButton) {
            this.agentChatAvailableElement.classList.remove('hide');
            if(this.noAgentChatAvailableElement !== null) {
                this.noAgentChatAvailableElement.classList.add('hide');
            }
        } else {
            this.agentChatAvailableElement.classList.add('hide');
            if(this.noAgentChatAvailableElement !== null) {
                this.noAgentChatAvailableElement.classList.remove('hide');
            }
        }
    }

    public setAgentAvailabilityCheckToEnd(): void
    {
         this.endAgentAvailabilityCheck = true;
    }

    private async checkAgentAvailability(): Promise<boolean>
    {
        const url = this.widgetConfig.getAgentChatAvailabilityUrl()+this.componentConfig.queue;

        try {
            const response = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
            });

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            const json = await response.json();
            return json.available;
        } catch (error) {
            console.error('Error:', error, 'URL:', url);
            return false;
        }
    }
}